module.exports = __webpack_public_path__ + "img/icwithdraw.e4964169.png";